import script from "./AddPuro.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPuro.vue?vue&type=script&setup=true&lang=js"

import "./AddPuro.vue?vue&type=style&index=0&id=32f2b20b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f2b20b"]])

export default __exports__